import { Components } from '@mui/material/styles';

const muiSvgIconsStyles: Components = {
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        // width: '20px',
        // height: '20px'
      }
    }
  }
};

export default muiSvgIconsStyles;
